import { FC } from "react";
import { Stack } from "capitalrx-components-2.0/lib/layout";
import { PharmacyFileSent } from "@/components";
import styles from "./PharmacyCommsFileSent.module.scss";


export const PharmacyCommsFileSent: FC = () => {

  return (
    <div className={styles.PharmacyPanelContainer}>
      <Stack spacing="large">
        <PharmacyFileSent />
      </Stack>
    </div>
  );
};

export default PharmacyCommsFileSent;
